import { C, SERIF, SANS, PAGE_W, PAGE_H } from "./theme";
import { ReportHeader, ReportFooter, Eyebrow, Label } from "./ReportChrome";
import { gbp, pct } from "./reportUtils";

export default function ExpectPage({ pageRef, host, address, cityName, T, low, high, city }) {
  return (
    <div ref={pageRef} style={{ width: PAGE_W, height: PAGE_H, background: "#fff", color: C.evergreen, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <ReportHeader host={host} address={address} cityName={cityName} />
      <div style={{ padding: "30px 64px 0", flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <Eyebrow>What to expect</Eyebrow>
        <h2 style={{ fontFamily: SERIF, fontWeight: 400, fontSize: 30, lineHeight: 1.1, letterSpacing: "-0.01em", margin: "10px 0 12px" }}>
          A realistic range, in a strong market
        </h2>
        <p style={{ fontFamily: SANS, fontSize: 12.5, lineHeight: 1.6, color: C.muted, maxWidth: 560, margin: 0 }}>
          No one can guarantee exactly what a property will earn, so here is how the year could look if it runs quieter or busier than expected. Fees are the same in every case.
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.15fr 1fr", marginTop: 26, alignItems: "stretch" }}>
          <div style={{ paddingTop: 22 }}>
            <Label>Quieter year</Label>
            <div style={{ fontFamily: SERIF, fontSize: 30, lineHeight: 1.3, marginTop: 6, paddingBottom: 6 }}>{gbp(low.net)}</div>
            <div style={{ fontFamily: SANS, fontSize: 10, color: C.muted, marginTop: 10 }}>{pct(low.occ)} occupancy, rates 5% lower</div>
          </div>
          <div style={{ background: C.tea, borderRadius: 14, padding: "22px 22px" }}>
            <Label color={C.evergreen}>Our estimate</Label>
            <div style={{ fontFamily: SERIF, fontSize: 38, lineHeight: 1.3, marginTop: 6, paddingBottom: 8 }}>{gbp(T.net)}</div>
            <div style={{ fontFamily: SANS, fontSize: 10, color: C.evergreen, marginTop: 10 }}>{pct(T.occ)} occupancy, {gbp(T.avgMonth)} a month</div>
          </div>
          <div style={{ paddingTop: 22, paddingLeft: 22 }}>
            <Label>Busier year</Label>
            <div style={{ fontFamily: SERIF, fontSize: 30, lineHeight: 1.3, marginTop: 6, paddingBottom: 6 }}>{gbp(high.net)}</div>
            <div style={{ fontFamily: SANS, fontSize: 10, color: C.muted, marginTop: 10 }}>{pct(high.occ)} occupancy, rates 5% higher</div>
          </div>
        </div>

        <div style={{ marginTop: 44 }}>
          <Eyebrow>Why {cityName}</Eyebrow>
          <h3 style={{ fontFamily: SERIF, fontWeight: 400, fontSize: 21, marginTop: 8 }}>Demand from several directions at once</h3>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", marginTop: 18, borderTop: `1px solid ${C.line}`, borderBottom: `1px solid ${C.line}` }}>
          {city.stats.map(([val, desc], i) => (
            <div key={val} style={{ padding: "18px 16px 18px 0", borderLeft: i ? `1px solid ${C.line}` : "none", paddingLeft: i ? 18 : 0 }}>
              <div style={{ fontFamily: SERIF, fontSize: 26, lineHeight: 1.3, paddingBottom: 4 }}>{val}</div>
              <div style={{ fontFamily: SANS, fontSize: 10, color: C.muted, marginTop: 8, lineHeight: 1.5 }}>{desc}</div>
            </div>
          ))}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", marginTop: 4 }}>
          {city.drivers.map(([title, body]) => (
            <div key={title} style={{ padding: "16px 20px 16px 0", borderTop: `1px solid ${C.line}` }}>
              <h4 style={{ fontFamily: SANS, fontWeight: 600, fontSize: 12, marginBottom: 5 }}>{title}</h4>
              <p style={{ fontFamily: SANS, fontSize: 10.5, lineHeight: 1.55, color: C.muted, margin: 0 }}>{body}</p>
            </div>
          ))}
        </div>
        <p style={{ fontFamily: SANS, fontSize: 10, lineHeight: 1.55, color: C.muted, marginTop: 18, maxWidth: 560 }}>
          Since 1 May 2026, Section 21 has gone and every AST is a periodic tenancy. A managed short-let sits outside that framework: you keep the flexibility to use the property yourself or change direction with 30 days' notice.
        </p>
      </div>
      <ReportFooter page={4} />
    </div>
  );
}